import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalCacheService {
    fetchData(key: string, storageType: string): any {
        try {
            if (storageType === 'local') {
                return localStorage.getItem(key);
            }
            return sessionStorage.getItem(key);
        } catch {
            return null;
        }
    }

    storeData(key: string, value: any, storageType: string): void {
        try {
            const data = typeof value === 'string' ? value : JSON.stringify(value);
            if (storageType === 'local') {
                localStorage.setItem(key, data);
            } else {
                sessionStorage.setItem(key, data);
            }
        } catch { }
    }
}
